export default __webpack_public_path__ + "static/media/KahshCardBg.3ad51695.png";